import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

// The read side lives in ./scim-breaker-override.js as `getScimCircuitBreakerDetail` — it
// selects the same fields plus `reason`, `breakerMaxDeprovisions` and `breakerDisabled`, and is
// the only breaker query the settings panel uses. A duplicate `getScimCircuitBreaker` query
// registration used to sit here with no importers; `invalidate("getScimCircuitBreaker")` still
// refreshes the surviving hook because api() keys on the inner function name, which is
// `getScimCircuitBreaker` there too.
const FIELDS = gql`
    fragment ScimBreaker on ScimCircuitBreakerStatus {
        tripped
        trippedAt
        deprovisionsInWindow
        windowMinutes
        thresholdPercent
        thresholdAbsolute
        minActiveForPercent
    }
`

export const resetScimCircuitBreaker = api(async function resetScimCircuitBreaker({ clientId } = {}) {
    return await mutate(
        gql`
            ${FIELDS}
            mutation resetScimCircuitBreaker($clientId: String) {
                resetScimCircuitBreaker(clientId: $clientId) {
                    ...ScimBreaker
                }
            }
        `,
        { clientId },
        { returns: "resetScimCircuitBreaker" }
    )
})
